import { useQuery, useMutation, UseQueryOptions } from '@tanstack/react-query'
import { Layout } from '../../shared/types'
import { del, get, post, put } from '../fetch'

export type LayoutsParamsType = {
	object: string
	type?: string
	name?: string
}

export function useLayoutsByIdentifier<T = Layout[]>(
	params: LayoutsParamsType,
	options?: Omit<UseQueryOptions<Layout[], Error, T>, 'queryKey' | 'queryFn'>,
) {
	return useQuery({
		...options,
		queryKey: ['api/layouts', params],
		queryFn: () => post<Layout[]>(`/api/0/layouts`, params),
		staleTime: Infinity,
		gcTime: Infinity,
		enabled: !!params.object,
	})
}

export function useLayoutsAll<T = Layout[]>(
	options?: Omit<UseQueryOptions<Layout[], Error, T>, 'queryKey' | 'queryFn'>,
) {
	return useQuery({
		...options,
		queryKey: ['api/layouts'],
		queryFn: () => get<Layout[]>(`/api/0/layouts`),
		staleTime: Infinity,
		gcTime: Infinity,
	})
}

export function useLayoutGet(id?: string) {
	return useQuery({
		queryKey: ['api/layouts', id],
		queryFn: () => get<Layout>(`/api/0/layouts/${id}`),
		enabled: !!id,
		staleTime: Infinity,
		gcTime: Infinity,
	})
}

export function useLayoutCreate() {
	return useMutation({
		mutationFn: (data: {
			object: string
			type: string
			name: string
			configuration: unknown
		}) => put('/api/0/layouts', data),
		meta: {
			invalidateQueries: [['api/layouts']],
			notifications: {
				success: () => 'Rozložení vytvořeno',
			},
		},
	})
}

export function useLayoutUpdate(id: string) {
	return useMutation({
		mutationFn: (
			data: Partial<{
				object: string
				type: string
				name: string
				configuration: unknown
			}>,
		) => post(`/api/0/layouts/${id}`, data),
		meta: {
			invalidateQueries: [['api/layouts']],
			notifications: {
				success: () => 'Změny uloženy',
			},
		},
	})
}

export function useLayoutRemove() {
	return useMutation({
		mutationFn: (id: string) => del(`/api/0/layouts/${id}`),
		meta: {
			invalidateQueries: [['api/layouts']],
			notifications: {
				success: () => 'Rozložení smazáno',
			},
		},
	})
}
